// Property pages (old site): the header's "Kontakt" only shows on the first image of the banner
// slider. It fades out as soon as the slider moves on and comes back when the visitor scrolls up
// or the slider is back at the first image.
export function propertyHeaderContact(sliders) {
	const contact = document.querySelector('.site__header--property .custom-header-content__contact')
	const banner = sliders.find((slider) => slider.root.closest('.section--property-banner'))

	if (!contact || !banner) return

	let lastY = window.scrollY

	banner.on('move', (newIndex) => {
		contact.classList.toggle('is-hidden', newIndex !== 0)
	})

	window.addEventListener(
		'scroll',
		() => {
			const y = window.scrollY
			if (y < lastY) contact.classList.remove('is-hidden')
			lastY = y
		},
		{ passive: true }
	)
}
